import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {AuthTokenService} from './auth-token.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authTokenService: AuthTokenService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this.authTokenService.isAuthenticated()
      .then(
        (authenticated: boolean) => {
          if (authenticated) {
            return true;
          } else {
            this.router.navigate(['login']);
          }
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth-guard.service.ts